import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CadastrarEmailComponent } from './cadastrar-email.component';
import { ComumModule } from "../../../shared/comum.module";
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';

@NgModule({
    declarations: [CadastrarEmailComponent],
    imports: [
        FormsModule,
        ComumModule,
        CheckboxModule,
        DropdownModule,
        ButtonModule,
        CommonModule,
        ToastModule
    ]
})
export class CadastrarEmailModule { }
